import { HttpClientOptions } from '../interfaces/core/http-client.interface';

export class ApiHttpConfig {
  static createWithBearer(token: string): HttpClientOptions {
    return {
      headers: { Authorization: `${token}` },
    };
  }

  static createWithBearerAcceptAll(token: string): HttpClientOptions {
    return {
      headers: { Authorization: `${token}`, Accept: '*/*' },
    };
  }
}
